import { render } from "./SetPasswordModal.vue?vue&type=template&id=87ce0806&scoped=true"
import script from "./SetPasswordModal.vue?vue&type=script&lang=js"
export * from "./SetPasswordModal.vue?vue&type=script&lang=js"

import "./SetPasswordModal.vue?vue&type=style&index=0&id=87ce0806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ce0806"]])

export default __exports__